import { useFulfillmentTypeEligibility } from "../../../../../hooks/useFulfillmentTypeEligibility";
import { useIneligibleForCourierStore } from "../../../../../hooks/useIneligibleForCourierStore";
import { useRemoteFeatureFlags } from "../../../../../hooks/useRemoteFeatureFlags";
import {
  SupplierRelationshipFulfillmentType,
  SupplierGetResponseType,
  SupplierStorefrontV2GetResponseType,
} from "@sellar-io/api-v2/types";
import { useStorefrontBuyerChoiceDeliveryOption } from "./useStorefrontBuyerChoiceDeliveryOptions";

export const useStorefrontBuyerChoiceDeliveryOptionDialogEligibility = ({
  supplier,
  connection,
  directDeliveryArea,
  sdDeliveryArea,
  checkoutSelectedFulfillmentType,
}: {
  supplier: SupplierGetResponseType | undefined;
  connection:
    | { fulfillmentType: SupplierRelationshipFulfillmentType | null }
    | undefined
    | null;
  directDeliveryArea:
    | SupplierStorefrontV2GetResponseType["DeliveryArea"]
    | undefined;
  sdDeliveryArea:
    | SupplierStorefrontV2GetResponseType["DeliveryArea"]
    | undefined;
  checkoutSelectedFulfillmentType:
    | SupplierRelationshipFulfillmentType
    | undefined;
}) => {
  const { buyersChoiceFulfillmentType, isValidBuyersChoiceFulfillmentType } =
    useStorefrontBuyerChoiceDeliveryOption({
      supplierId: supplier?.id ?? 0,
    });

  const { hasItemIneligibleForCourier } = useIneligibleForCourierStore();

  const palletOverrideEnabled = useRemoteFeatureFlags().isActive(
    "courierHaulierEnforcement",
  );

  const eligibility = useFulfillmentTypeEligibility({
    allowCollectionOnCheckout: Boolean(supplier?.allowCollectionOnCheckout),
    connection,
    directDeliveryArea,
    sdDeliveryArea,
    eligibleForHaulierOverride:
      hasItemIneligibleForCourier && palletOverrideEnabled,
  });

  const { isEligibleForDirect, isEligibleForDistribution } = eligibility;

  const isEligibleForBuyerChoice =
    !buyersChoiceFulfillmentType &&
    Boolean(checkoutSelectedFulfillmentType) &&
    isValidBuyersChoiceFulfillmentType(checkoutSelectedFulfillmentType) &&
    isEligibleForDirect &&
    isEligibleForDistribution;

  return {
    isEligibleForBuyerChoice,
  };
};
